<template>
  <div class="page">
    <!-- data-io-click="tracker"  @click.stop="hiddenGuideTip" -->
    <!-- <Header
      ref="headerCom"
      :isShowMask="isShowMask"
      :maskStyle="maskStyle"
      v-if="showSkeleton"
      @changeFeedbackDialogVisible="changeFeedbackDialogVisible"
      @changeRizhiDialogVisible="changeRizhiDialogVisible"
      @changeAddCourseDialogVisible="changeAddCourseDialogVisible"
      @openSetting="changeOpenSettingDialogVisible"
    ></Header> -->
    <!-- functionMenu.length > 0 && -->
    <Aside
      @changeFeedbackDialogVisible="changeFeedbackDialogVisible"
      @changeRizhiDialogVisible="changeRizhiDialogVisible"
      :isShowMask="isShowMask"
      :maskStyle="maskStyle"
      v-if="showSkeleton && !isInIframe"
      @toPath="toPath"
      @toLoginLayout="toLoginLayout"
      @openNoAuthDialog="openNoAuthDialog"
      :menus="asideMenus"
      :userModuleAuth="userModuleAuth"
      @openSetting="changeOpenSettingDialogVisible"
      :enterWxtStatus="roleStatus"
      :loginStatus="loginStatus"
    >
    </Aside>
    <div class="xep-aside">
      <xep-platform-aside
        ref="xepAside"
        v-if="showXepAside"
        @change-nav="changeNav"
      ></xep-platform-aside>
    </div>
    <!-- 'is-folded-layout-content': isFolded && !isInIframe, -->
    <div
      class="layout-content"
      :class="{
        'no-show-skeleton': !showSkeleton,
        'show-xep-aside': isInIframe && showXepAside,
        'no-show-aside': isInIframe && !showXepAside,
        showSetDialog: showSetDialog,
        'is-full-screen': isFullScreen,
      }"
    >
      <router-view
        ref="childComponent"
        @showSetDialog="showSetDialogFunction"
        @openTextbookEncyclopediaDialog="openTextbookEncyclopediaDialog"
      ></router-view>
    </div>
    <!-- <timeLineModal
      @closeModal="changeRizhiDialogVisible(false)"
      :rizhiDialogVisible="rizhiDialogVisible"
    /> -->
    <!-- 反馈意见 -->
    <feedBackModal
      @closeModal="changeFeedbackDialogVisible(false)"
      type="建议"
      v-if="feedbackDialogVisible"
      :feedbackDialogVisible="feedbackDialogVisible"
    ></feedBackModal>
    <!-- 用户设置 -->
    <custom-set
      :dialogVisible="settingDialogVisible"
      :textbooks="textbooks"
      @deleteBook="deleteTextbook"
      @closeModal="changeOpenSettingDialogVisible(false)"
      @setFeaturesSuccess="handleSetFeaturesSuccess"
    ></custom-set>
    <!-- 添加教材 -->
    <choose-dialog
      :chooseDialogFlag.sync="chooseDialogFlag"
      @submitSuccess="addTextbookSuccess"
      @close="handleCloseChooseDialog"
      :triggerType="triggerType"
      :userTextbooks="textbooks"
    ></choose-dialog>
    <add-course
      ref="addCourse"
      :isVisible="isAddCourseVisible"
      :userCourses="userCourses"
      :isAddCoursesAgain="isAddCoursesAgain"
      :stagesProp="stages"
      :isSchoolBased="isSchoolBased"
      :triggerType="triggerType"
      @close="handleCloseAddCourseDialog"
    ></add-course>
    <!-- <suggestion
      ref="suggestionBanner"
      v-if="showSkeleton"
      @feedback="changeFeedbackDialogVisible"
    ></suggestion> -->
    <DeleteDialog
      :visible="deleteVisible"
      ref="deleteDialog"
      :showTitle="false"
      :showUserCourse="showUserCourse"
      :userInfo="userInfo"
      :desc="`${this.deleteTip}课程下存在备课资料，删除课程后该课程下的<i class='key' style='font-style: normal;font-weight: 600;'>全部备课资料会一起删除</i>，是否确定删除？`"
      @handleClose="handleClose"
      @handleDelete="handleDelete"
    >
    </DeleteDialog>
    <!-- <NoticeDrawer
      @closeNoticeDrawer="handleCloseNoticeDrawer"
      v-if="showSkeleton"
      :showDrawer="showDrawer"
    /> -->
    <div
      v-if="loginPopupVisible"
      class="mask_1"
      data-io-click="tracker"  @click="loginPopupVisible = false"
    >
      <div class="login_popup">
        <i class="iconfont icon-close" />
        <iframe
          id="dialogLoginIframe"
          allowtransparency="true"
          :src="`https://${protocolName}.zxxk.com/login?dialogTheme=true&service=https%3A%2F%2Fauth.zxxk.com%2Fuser%2Fdialogcallback%3Furl%3D${backUrl()}&dialogTheme=true`"
          frameborder="0"
          style="
            border: 0px;
            height: 570px;
            width: 501px;
            top: calc(50% - 285px);
            left: calc(50% - 250px);
          "
          class="SSO_overlay_1653547238506popup"
        />
      </div>
    </div>
    <!-- <iframe
      class="login-iframe"
      :src="`https://${protocolName}.xkw.com/login?service=https%3A%2F%2Fauth.xkw.com%2Fuser%2Fasynclogin`"
      frameborder="0"
    ></iframe>
    <iframe
      class="login-iframe"
      id="loginIframe"
      :src="`https://${protocolName}.xkw.com/login?service=https%3A%2F%2Fauth.zxxk.com%2Fuser%2Fasynclogin`"
      frameborder="0"
    ></iframe> -->
    <!-- <GuideTip
      ref="guideTip"
      :tipList="tipList"
      :showTip="showTip"
      v-show="showTip"
      @closeTip="showTip = false"
    /> -->
    <ScrollTop v-if="showScrollTop" :visibile="showScrollTop" />

    <!--  //页面的遮罩层-->
    <div id="cover" v-if="showSetDialog"></div>

    <!--    教材百科-->
    <div v-if="textbookEncyclopediaDialogStatus">
      <TextbookEncylopedia
        @closeTextbookEncyclopediaDialog="closeTextbookEncyclopediaDialog"
      ></TextbookEncylopedia>
    </div>
  </div>
</template>
<script>
import tracker from "@/assets/js/statistics/xkw.tracker";
import addCourse from "@/components/addCourse";
import chooseDialog from "@/components/choose.vue";
import CostDialog from "@/components/CostDialog.vue";
import DeleteDialog from "@/components/DeleteDialog.vue";
import feedBackModal from "@/components/feedBackModal";
import GuideTip from "@/components/GuideTip.vue";
import ScrollTop from "@/components/ScrollTop";
import suggestion from "@/components/suggestion.vue";
import Aside from "@/pages/layout/components/aside";
import Header from "@/pages/layout/components/header";
// import { baiduHm } from "@/assets/js/statistics/hm";
import util from "@/assets/js/common/util";
import course from "@/assets/js/mixin/course";
import getUserTextbooks from "@/assets/js/mixin/getUserTextbook";
import tongji from "@/assets/js/mixin/tongji";
import api from "@/assets/js/service/api";
import customSet from "@/components/customSet";
import NoticeDrawer from "@/components/NoticeDrawer";
import TextbookEncylopedia from "@/components/TextbookEncylopedia";
import timeLineModal from "@/components/timeLineModal";
import {
  getSchoolAuth,
  getScsyStageAndSubjectList,
  getStages,
  getSyncCourseList,
  getUserLoginStatus,
  getUserModuleAuth,
  getUserRoleInfoStatus,
  protocolName,
  updateLastUsedCourse,
} from "@/utils/apis";
import request from "@/utils/request";
import Cookie from "js-cookie";
import qs from "qs";
import { mapMutations, mapState } from "vuex";
let isInIframe = util.judgeInIframe();
// 是否显示更新弹层
const IS_SHOW_UPDATE_DRAWER = "IS_SHOW_UPDATE_DRAWER";
// 备课同步用户的课程
const SYNC_USER_COURSES = "SYNC_USER_COURSES";
const CURRENTCOURSE = "CURRENTCOURSE";
const WHEREISFROMLAB = "WHEREISFROMLAB";
// 显示新手引导提示
const SHOW_NOVICE_GUIDANCE = "SHOW_NOVICE_GUIDANCE";
// 显示实验引导提示
const SHOW_SY_GUIDANCE = "SHOW_SY_GUIDANCE";
const SHOW_NEW_MODEL_GUIDANCE = "SHOW_NEW_MODEL_GUIDANCE";
// 是否初次显示新目录展开
const SHOW_NEW_MENU_OPEN_STATUS = "SHOW_NEW_MENU_OPEN_STATUS";
// 打开的左侧导航id
const OPENSIDENAVLISTS = "OPENSIDENAVLISTS";
let isAddCourse = false;
export default {
  data() {
    return {
      textbookEncyclopediaDialogStatus: false,
      functionMenu: [],
      rizhiDialogVisible: false,
      feedbackDialogVisible: false,
      // 用户设置弹窗
      settingDialogVisible: false,
      triggerType: "主动",
      // 是否显示通知抽屉
      showDrawer: false,
      // 是否是嵌入在iframe中
      // isInIframe: false,
      // iframe嵌入的课程id
      iframeCourseId: 0,
      asideWidth: 0,
      deleteTip: "",
      deleteVisible: false,
      // deleteIds: [],
      showUserCourse: [],
      showSkeleton: true,
      xepUrl: "",
      // 是否显示遮罩
      isShowMask: false,
      maskStyle: { visible: true, background: "#000000", opacity: 0.5 },
      tipList: [],
      showTip: false,
      // 是否显示再次添加课程弹窗
      isAddCoursesAgain: false,
      // 仅有实操实验权限
      isOnlyScsy: false,
      // 用户只有实验权限
      userOnlySyRole: false,
      // 是否是校本
      isSchoolBased: false,
      // 实操实验学段学科列表
      scsyStageListAndSubjects: [],
      // 同步内容学段学科
      syncStageListAndSubjects: [],
      // 是否显示登录弹窗
      loginPopupVisible: false,
      // 是否显示新手引导
      showNoviceGuidance: false,
      isSchoolAuth: false,
      isLoaded: false,
      // 显示滚动到顶部按钮
      showScrollTop: false,
      userModuleAuth: null,
      showCostDialog: true,
      // userInfo: null,
      showSetDialog: false,
      roleStatus: null,
      isOnlyResourceCardRight: false,
      isOnlyAiRight: false,
      asideMenus: null,
      isOnlyAiKxRight: false,
      allNavs: [],
      activeNav: null,
      protocolName,
      loginIframeLoadPromise: null,
      resolveIframeLoad: null,
      iframeInitialized: false,
      isLoginSynced: false,
      loginStatus: false,
    };
  },
  mixins: [getUserTextbooks, course, tongji],
  provide() {
    return {
      textbook: this,
    };
  },
  computed: {
    ...mapState({
      userInfo: "userInfo",
      currentCourse: "currentCourse",
      currentGuideTipClassName: "currentGuideTipClassName",
      isFolded: "isFolded",
      isInIframe: "isInIframe",
      showWxtGuidance: "showWxtGuidance",
      showNoviceGuidanceVisible: "showNoviceGuidanceVisible",
      showSyGuidance: "showSyGuidance",
      hasSyRoles: "hasSyRoles",
      userTools: "userTools",
      showNewModalTip: "showNewModalTip",
      systemTools: "systemTools",
      currentTextbook: "currentTextbook",
      isFullScreen: (state) => state.isFullScreen,
    }),
    // 展示xep导航栏的显示逻辑
    showXepAside() {
      return !!this.$route.query.xep_flag;
    },
    // 展示应用组件的显示逻辑
    showDesktop: function () {
      return this.activeNav?.navCode === "gzt";
    },
  },
  watch: {
    $route: {
      async handler(to, from) {
        let { path } = to;
        // console.log("from,to", from, to);
        if (from && from.path.indexOf("/xiaoben") > -1) {
          this.judgeCurrentCourseAuthorized();
        }
        if (!from || to.path != from.path) {
          this.judgeProductTypeId();
          // !to.path.startsWith("/soft") &&
          // console.log('to.path.startsWith("/lab/visitreport")', to.path.startsWith("/lab/visitreport"))
          this.showSkeleton =
            !to.path.startsWith("/equity") &&
            !to.path.startsWith("/report") &&
            !to.path.startsWith("/lab/playreport") &&
            !to.path.startsWith("/lab/visitreport") &&
            !to.path.startsWith("/sci/zn");
          this.showScrollTop =
            path.indexOf("/tech") > -1 ||
            path.indexOf("/lab") > -1 ||
            path.indexOf("/school-based") > -1 ||
            path.indexOf("/zyk") > -1;
          // console.log('to,from',to,from)
          if (
            to.path.startsWith("/soft") ||
            to.path.startsWith("/docpack") ||
            to.path.startsWith("/vocabulary")
          ) {
            // this.isFolded = true;
            this.changeIsFolded(true);
          }
          // && this.isLoaded
          if (
            from &&
            to &&
            to.path != from.path &&
            path.indexOf("/welcome") == -1
          ) {
            // console.log("切换路由当前课程", this.currentCourse);
            this.judgePermissionShow();
            if ((path == "/" || path == "/desktop") && !this.isInIframe) {
              // await this.getUserModuleAuth();
              this.handleNoviceGuidance();
            }
          }
        }

        const query = this.$route.query;
        this.$nextTick(() => {
          query.xep_flag &&
            path.indexOf("/zyk") > -1 &&
            this?.$refs?.xepAside?.changeNavApi("yzyk");
        });
        // let isInIframe = util.judgeInIframe();
        // 调用统计方法
        tracker.constructTracker(
          {
            stageId: query.stageId,
            subjectId: query.subjectId,
            versionId: query.textbookId,
          },
          this.userInfo,
          isInIframe
        );
        this.loadTongji();
        // baiduHm();
      },
      deep: true,
      immediate: true,
    },
    currentCourse: {
      async handler(to, from) {
        // console.log("to, from", to, from);
        let path = this.$route.path;
        this.getUserLoginStatus();
        //获取登录状态
        // this.getUserFunctions();
        if ((!from && to) || (from && to && from.courseId != to.courseId)) {
          // this.showTip;
          this.loadTextbooks();
          this.judgeCurrentCourseIsOnlyScsy();
          this.judgeCurrentCourseIsOnlyResourceCardRight();
          this.judgeCurrentCourseIsOnlyAi();
          // console.log("to,from", to, from);
          // this.getUserFunctions({
          //   courseId: to.courseId,
          // });
          if (
            from?.courseId &&
            to?.courseId &&
            from.courseId != to.courseId &&
            this.isInIframe
          ) {
            // console.log("textbook2222", this.currentTextbook, to);
            this.$refs?.xepAside?.saveUserPreferenceApi({
              courseId: to.courseId,
              textbookId:
                to?.bookList?.[0]?.versionName === "不限" ||
                !to?.bookList?.length
                  ? ""
                  : to?.bookList?.[0]?.bookId,
              bookVersionId:
                to?.bookList?.[0]?.versionName === "不限"
                  ? ""
                  : to?.bookList?.[0]?.versionId,
            });
          }
        }
        if (!from && to && path.indexOf("/welcome") == -1) {
          // 初次访问页面显示权限弹窗
          // console.log("初次访问页面显示权限弹窗");
          // this.judgePermissionShow();
        }
      },
      deep: true,
      immediate: true,
    },
    // showXepAside: {
    //   handler(newVal, oldVal) {
    //     if (newVal && this.$route.path.indexOf("zyk") > -1) {
    //       this.$nextTick(() => {
    //         this?.$refs?.xepAside?.changeNavApi("yzyk");
    //       });
    //     }
    //   },
    //   immediate: true,
    // },
    userInfo: {
      handler(newVal, oldVal) {
        if (newVal) {
          let roles = newVal.roles || [];
          let aiKxRole = roles.filter(
            (role) => role.simpleName.indexOf("aikx") > -1
          );
          if (aiKxRole && aiKxRole.length && aiKxRole.length == roles.length) {
            this.isOnlyAiKxRight = true;
          }
          if (
            this.$route.path.indexOf("/sci") > -1 &&
            (!aiKxRole || !aiKxRole.length)
          ) {
            this.$router.replace("/desktop");
          }
        }
      },
      immediate: true,
    },
    // loginPopupVisible(newVal) {
    //   if (newVal) {
    //     this.$nextTick(() => {
    //       const loginIframe = document.getElementById("dialogLoginIframe");
    //       if (loginIframe) {
    //         loginIframe.onload = () => {
    //           this.iframeLoaded = true;
    //           this.resolveIframeLoad();
    //           console.log("iframe loaded");
    //         };
    //       }
    //     });
    //   }
    // },
  },
  created() {
    // 创建一个 Promise 用于跟踪 iframe 加载状态
    // this.loginIframeLoadPromise = new Promise((resolve) => {
    //   this.resolveIframeLoad = resolve;
    // });
  },
  async mounted() {
    console.log("layout mounted");
    // 先初始化 iframe Promise
    // await this.initIframePromise();
    this.init();
    let isInIframe = util.judgeInIframe();
    this.changeIsInIframe(isInIframe);
    await this.getUserModuleAuth(true);
    let path = this.$route.path;
    let isLabReportPage =
      path.indexOf("/lab/playreport") > -1 ||
      path.indexOf("/lab/visitreport") > -1;
    let isReadPage = path.indexOf("/read") > -1;
    // 获取阅读当前课程
    // this.getUserCurrentReadCourse();
    this.initMessageListener();
    this.$nextTick(() => {
      this.isInIframe && (this.xepAside = this.$refs.xepAside);
    });
    if (this.isInIframe) {
      // this.asideWidth =
      //   parent.document.getElementById("xep-platform-aside").offsetWidth;
      // let xepUrl = util.getIframeUrl();
      // this.iframeCourseId = util.getIframeCourseId();
      // console.log("iframeCourseId", iframeCourseId);
      // this.xepUrl = xepUrl;
      document.body.style.minWidth = "800px";
    }
    // await this.getStages()

    !isLabReportPage &&
      (path.indexOf("/welcome") == -1 || path.indexOf("/zyk/juemi") > -1) &&
      (await this.judgePermissionShow());
    !isLabReportPage && (await this.handleSyncUserCourses());
    if (!isLabReportPage) {
      let { result: isSchoolAuth } = await getSchoolAuth();
      this.isSchoolAuth = isSchoolAuth;
    }
    // 是否弹窗
    if ((path == "/" || path == "/desktop") && !this.isInIframe) {
      this.handleNoviceGuidance();
    }
    // 调用统计方法
    tracker.tracker();
    if (this.textbooks.length) {
      const textbook = this.textbooks[0];

      tracker.constructTracker(
        {
          stageId: textbook.stageId,
          subjectId: textbook.subjectId,
          versionId: textbook.bookId,
        },
        this.userInfo,
        isInIframe
      );
    }
    this.getUserLoginStatus();
    // 处理消息通知
    // this.$nextTick(() => {
    //   // 非新用户才显示更新日志
    //   this.userCourses.length && this.initUpdateNotice();
    // });
    // this.initIframePromise();
  },
  methods: {
    ...mapMutations({
      setTextbooks: "setTextbooks",
      setCourses: "setCourses",
      setCurrentCourse: "setCurrentCourse",
      setUserTools: "setUserTools",
      setSchoolBaseChildMenu: "setSchoolBaseChildMenu",
      setStageListAndSubjects: "setStageListAndSubjects",
      setDeleteIds: "setDeleteIds",
      changeIsInIframe: "changeIsInIframe",
      changeIsFolded: "changeIsFolded",
      changeShowWxtGuidance: "changeShowWxtGuidance",
      changeShowNoviceGuidanceVisible: "changeShowNoviceGuidanceVisible",
      changeShowSyGuidance: "changeShowSyGuidance",
      changeHasSyRoles: "changeHasSyRoles",
      changeShowNewModalTip: "changeShowNewModalTip",
      changeShowNewModelGuidance: "changeShowNewModelGuidance",
    }),
    changeNav(activeNav, allNavs) {
      this.activeNav = activeNav;
      this.allNavs = allNavs;
    },
    judgeCurrentCourseAuthorized() {
      // console.log("currentCourse", this.currentCourse);
      // 判断本地课程
      let currentCourse =
        localStorage.getItem(`${this.userInfo.userId}-` + CURRENTCOURSE) ||
        null;
      // console.log("----currentCourse", currentCourse);
      if (currentCourse && this.currentCourse) {
        currentCourse = JSON.parse(currentCourse);
        if (currentCourse.id != this.currentCourse.courseId) {
          // 重新设置当前课程
          localStorage.setItem(
            `${this.userInfo.userId}-` + CURRENTCOURSE,
            JSON.stringify(this.currentCourse)
          );
        }
      }
    },
    backUrl() {
      return encodeURIComponent(window && window.location.href);
    },
    async getUserModuleAuth(isReset = false) {
      let asideMenus = [];
      let path = this.$route.path;
      let data = await getUserModuleAuth();
      const showNewMenuOpenStatus =
        localStorage.getItem(SHOW_NEW_MENU_OPEN_STATUS) || false;
      let openSideNavLists = localStorage.getItem(OPENSIDENAVLISTS);
      openSideNavLists = openSideNavLists ? JSON.parse(openSideNavLists) : [];
      if (data.code === 200) {
        this.functionMenu = data.result.functionList;
        this.functionMenu.forEach((item) => {
          item.children = item.childFunctions;
          item.isParent = true;
          if (item.showFlag && !item.childFunctions) {
            this.$set(item, "isActive", path.indexOf(item.redirectUrl) > -1);
            // item.isOpen = path.indexOf(item.redirectUrl) > -1;
            asideMenus.push(item);
          } else if (
            item.showFlag &&
            item.childFunctions &&
            item.childFunctions.length
          ) {
            let showChildFunctions = item.childFunctions.filter(
              (child) => child.showFlag
            );
            if (showChildFunctions && showChildFunctions.length == 1) {
              showChildFunctions[0].isParent = true;
              this.$set(
                showChildFunctions[0],
                "isActive",
                path.indexOf(showChildFunctions[0].redirectUrl) > -1
              );
              // item.childFunctions[0].isOpen =
              //   path.indexOf(item.childFunctions[0].redirectUrl) > -1;
              asideMenus.push(showChildFunctions[0]);
            } else if (showChildFunctions && showChildFunctions.length > 1) {
              let isActive = false;
              let showChildFunctions = item.childFunctions.filter((item) => {
                if (path.indexOf(item.redirectUrl) > -1) {
                  isActive = true;
                }
                return item.showFlag;
              });
              item.children = showChildFunctions;
              let parentStatus = !showNewMenuOpenStatus || isActive;
              if (!showNewMenuOpenStatus) {
                localStorage.setItem(SHOW_NEW_MENU_OPEN_STATUS, true);
              }
              if (isReset && openSideNavLists && openSideNavLists.length) {
                let currentNavMenu = openSideNavLists.find(
                  (nav) => nav == item.functionId
                );
                currentNavMenu ? (parentStatus = true) : null;
              }
              this.$set(item, "isActive", isActive);
              this.$set(item, "isOpen", parentStatus);
              // item.isOpen = isOpen;
              showChildFunctions.length > 1 ? asideMenus.push(item) : null;
            }
            // if (
            //   item.childFunctions.length == 1 &&
            //   item.childFunctions[0].showFlag
            // ) {
            //   item.childFunctions[0].isParent = true;
            //   this.$set(
            //     item.childFunctions[0],
            //     "isActive",
            //     path.indexOf(item.childFunctions[0].redirectUrl) > -1
            //   );
            //   // item.childFunctions[0].isOpen =
            //   //   path.indexOf(item.childFunctions[0].redirectUrl) > -1;
            //   asideMenus.push(item.childFunctions[0]);
            // } else {
            //   let isActive = false;
            //   let showChildFunctions = item.childFunctions.filter((item) => {
            //     if (path.indexOf(item.redirectUrl) > -1) {
            //       isActive = true;
            //     }
            //     return item.showFlag;
            //   });
            //   item.children = showChildFunctions;
            //   this.$set(item, "isActive", isActive);
            //   this.$set(item, "isOpen", isActive);
            //   // item.isOpen = isOpen;
            //   showChildFunctions.length > 1 ? asideMenus.push(item) : null;
            // }
          }
        });
        this.asideMenus = asideMenus;
        // console.log('----asideMenu',asideMenus)
        // data.result.functionList.forEach()
        // this.functionMenu.forEach((item) => {
        //   if (item.childFunctions && item.childFunctions.length > 0) {
        //     let findItem = item.childFunctions.find(
        //       (item) => item.redirectUrl == "/school-based"
        //     );
        //     if (findItem) {
        //       item.redirectUrl = findItem.redirectUrl;
        //     }
        //     if (item.functionName == "校本") {
        //       this.setSchoolBaseChildMenu(item.childFunctions);
        //     }
        //   }
        // });
        this.userModuleAuth = data.result;
      }
    },
    // 获取用户功能模块
    // async getUserFunctions(params) {
    //   const data = await getUserFunctions(params);
    //   // console.log("data", data);
    //   if (data.code === 200) {
    //     this.functionMenu = data.result;
    //     this.functionMenu.forEach((item) => {
    //       if (item.childFunctions && item.childFunctions.length > 0) {
    //         let findItem = item.childFunctions.find(
    //           (item) => item.redirectUrl == "/school-based"
    //         );
    //         if (findItem) {
    //           item.redirectUrl = findItem.redirectUrl;
    //         }
    //         if (item.functionName == "校本") {
    //           this.setSchoolBaseChildMenu(item.childFunctions);
    //         }
    //       }
    //     });
    //   }
    // },
    async getUserLoginStatus() {
      //获取登录状态
      const data = await getUserLoginStatus();
      //用户登录状态
      this.loginStatus = data.success;
      this.getUserRoleInfoStatus();
    },
    //用来判断此用户是否可进入网校通
    async getUserRoleInfoStatus() {
      const data = await getUserRoleInfoStatus();
      // console.log(data);
      if (data.code === 200) {
        this.roleStatus = data.result.enterWxtStatus;
        // console.log(data.result.enterWxtStatus);
      }
    },
    async initCourseLists() {
      let { result: syncStageListAndSubjects } = await getSyncCourseList();
      this.syncStageListAndSubjects = syncStageListAndSubjects || [];
      let { result: scsyStageListAndSubjects } =
        await getScsyStageAndSubjectList();
      this.scsyStageListAndSubjects = scsyStageListAndSubjects || [];
      this.isLoaded = true;
    },
    init() {
      if (window.XEP) {
        // do init
        window.XEP.init({
          window: {
            id: "wxt",
            left: 0, // 网校通左侧导航宽度，下载收藏页面没有，传0即可
            top: 0, // 网校通顶部导航高度，下载收藏页面没有，传0即可
          },
          message: {
            onReceive: this.receiveMsg,
            // 根据需要绑定消息接收事件
          },
        });
        // console.log("XEP");
        // console.log(window.XEP);
        return;
      }
      setTimeout(this.init, 200);
    },
    async judgePermissionShow() {
      let path = this.$route.path;
      if (
        path == "/" ||
        path == "/desktop" ||
        path.indexOf("/zyk") > -1 ||
        (path.indexOf("/lab") > -1 &&
          path.indexOf("/lab/playreport") === -1 &&
          path.indexOf("/lab/visitreport") === -1) ||
        path.indexOf("/shk") > -1 ||
        path.indexOf("/read") > -1 ||
        path.indexOf("/jb") > -1 ||
        path.indexOf("/bj") > -1 ||
        path.indexOf("/bk") > -1
      ) {
        // console.log("判断是否有权限", path.indexOf("/lab") > -1);
        // 判断当前课程是否有权限如果没有权限显示添加课程弹窗
        await this.judgeCurrentCoursePermission();
      }
    },
    receiveMsg() {
      // console.log("初始化完成----");
      let { left } = window.XEP.window.getLayout();
      this.asideWidth = left;
    },
    handleNoviceGuidance() {
      // console.log("工作台引导提示");
      let userInfo = this.userInfo;
      let roles = userInfo.roles;
      let syRoles =
        roles.filter(
          (role) => role.simpleName.indexOf("sy") > -1
          // role.simpleName.indexOf("nbsy") > -1
        ) || [];
      this.userOnlySyRole = syRoles.length == roles.length;
      this.isOnlyScsy = syRoles.length == roles.length;
      if (
        this.isOnlyScsy &&
        (!userInfo.resourceCardVO ||
          !userInfo.resourceCardVO.resourceCardBalance)
      ) {
        this.$router.push("/lab");
        return;
      }
      let wxtRoles =
        roles.filter((role) => role.simpleName.indexOf("wxt") > -1) || [];
      if (wxtRoles.length > 0) {
        // 既有实验权限又有网校通权限
        let showNoviceGuidance =
          localStorage.getItem(SHOW_NOVICE_GUIDANCE) || false;
        let showSyGuidance = localStorage.getItem(SHOW_SY_GUIDANCE) || false;
        // 测试
        if (!showNoviceGuidance || !showSyGuidance) {
          if (this.asideMenus && this.asideMenus.length) {
            this.asideMenus.forEach((menu) => {
              this.$set(menu, "isOpen", true);
            });
          }
          // console.log("显示新手引导");
          // 显示新手引导
          this.changeShowNoviceGuidanceVisible(true);
          // 显示左侧目录树引导
          this.changeShowWxtGuidance(!showNoviceGuidance);
          // 显示过工作台引导只需要显示实验提示
          showNoviceGuidance &&
            !showSyGuidance &&
            syRoles.length > 0 &&
            this.changeShowSyGuidance(!showSyGuidance);
          localStorage.setItem(SHOW_NOVICE_GUIDANCE, true);
          syRoles.length > 0
            ? localStorage.setItem(SHOW_SY_GUIDANCE, true)
            : null;
          this.changeHasSyRoles(syRoles.length > 0);
          // window.XEP.dialog.mask(true);
        } else {
          // console.log("用户信息");
          this.handleOtherModal();
        }
      }
    },
    handleNewModalTip() {
      // let newLists = [];
      let status = localStorage.getItem(SHOW_NEW_MODEL_GUIDANCE) || false;
      // console.log("是否显示", status,this.systemTools);
      let newLists = this.systemTools.filter((module) => module.isNew);
      let newIds = [];
      newLists.forEach((newItem) => {
        this.userTools.forEach((tool) => {
          tool.forEach((item) => {
            if (newItem.moduleId == item.moduleId) {
              newIds.push(item);
            }
          });
        });
      });

      // this.userTools.forEach((tool) => {
      //   tool.forEach((item) => {
      //     if (item.isNew) {
      //       newLists.push(item);
      //     }
      //   });
      // });
      // console.log("newLists", newLists);
      if (newIds.length < newLists.length && !status) {
        // this.showNewModalTip = true;
        this.changeShowNewModelGuidance(true);
        localStorage.setItem(SHOW_NEW_MODEL_GUIDANCE, true);
      }
    },
    async handleOtherModal() {
      // console.log("userTools", this.userTools);
      this.handleNewModalTip();
      let path = this.$route.path;
      // console.log("判断当前用户选择过得课程是否存在", this.userCourses);
      // let showAddCourseStatus = true;
      // for (let i = 0; i < this.userCourses.length; i++) {
      //   let item = this.userCourses[i];
      //   if (item?.courseList?.length) {
      //     let findItem = item.courseList.find((item) => {
      //       return item.isUse;
      //     });
      //     if (findItem) {
      //       showAddCourseStatus = false;
      //       return;
      //     }
      //   }
      // }
      // // 在新手引导之后显示
      // if (showAddCourseStatus) {
      //   this.triggerType = "被动";
      //   this.changeAddCourseDialogVisible(
      //     showAddCourseStatus,
      //     this.triggerType
      //   );
      // }
      // 在新手引导之后在执行
      // if (
      //   path == "/" ||
      //   path == "/desktop" ||
      //   path.indexOf('zyk') > -1 ||
      //   path.indexOf("/lab") > -1 ||
      //   path.indexOf("/content") > -1 ||
      //   path.indexOf("/read") > -1
      // ) {
      //   // 判断当前课程是否有权限如果没有权限显示添加课程弹窗
      //   await this.judgeCurrentCoursePermission();
      // }
      // this.judgePermissionShow()
      // 处理消息通知 在新手引导之后显示
      this.$nextTick(() => {
        // 非新用户才显示更新日志
        this.userCourses.length && this.initUpdateNotice();
      });
    },
    // 新手引导结束
    handleDesktopGuidanceEnd() {
      // console.log("新手引导结束");
      this.handleOtherModal();
    },
    getCurrentCourseRoles() {
      // console.log("currentCourse----", this.currentCourse);
      if (this.currentCourse) {
        let simpleStage = util.stagesMap[this.currentCourse.stageId];
        let roles = this.userInfo.roles;
        let targetRoles = roles.filter((role) =>
          role.simpleName.startsWith(simpleStage)
        );
        return targetRoles;
      }
    },
    judgeCurrentCourseIsOnlyScsy() {
      let targetRoles = this.getCurrentCourseRoles();
      let filterRoles =
        targetRoles.filter(
          (role) => role.simpleName.indexOf("sy") > -1
          // role.simpleName.indexOf("nbsy") > -1
        ) || [];
      this.isOnlyScsy = targetRoles.length == filterRoles.length;
    },
    judgeCurrentCourseIsOnlyAi() {
      let targetRoles = this.getCurrentCourseRoles();
      let filterRoles =
        targetRoles.filter(
          (role) => role.simpleName.indexOf("wxt") > -1
          // role.simpleName.indexOf("nbsy") > -1
        ) || [];
      let aifilterRoles =
        targetRoles.filter(
          (role) => role.simpleName.indexOf("ai") > -1
          // role.simpleName.indexOf("nbsy") > -1
        ) || [];
      // console.log("aifilterRoles", aifilterRoles);
      this.isOnlyAiRight =
        this.userInfo &&
        aifilterRoles.length > 0 &&
        (!filterRoles || !filterRoles.length);
    },
    judgeCurrentCourseIsOnlyResourceCardRight() {
      let targetRoles = this.getCurrentCourseRoles();
      let filterRoles =
        targetRoles.filter(
          (role) => role.simpleName.indexOf("wxt") > -1
          // role.simpleName.indexOf("nbsy") > -1
        ) || [];
      let syfilterRoles =
        targetRoles.filter(
          (role) => role.simpleName.indexOf("sy") > -1
          // role.simpleName.indexOf("nbsy") > -1
        ) || [];
      this.isOnlyResourceCardRight =
        this.userInfo &&
        this.userInfo.resourceCardVO &&
        this.userInfo.resourceCardVO.resourceCardBalance > 0 &&
        (!filterRoles || !filterRoles.length) &&
        (!syfilterRoles || !syfilterRoles.length);
    },
    async judgeCurrentCoursePermission() {
      // console.log("判断当前课程权限");
      // let { stageId, subjectId } = this.currentCourse;
      let path = this.$route.path;
      let isLab =
        path.indexOf("/lab") > -1 && path.indexOf("/lab/welcome") == -1;
      let isZyk = path.indexOf("/zyk") > -1;
      let isExcludePage = path == "/" || path == "/desktop" || isZyk;
      let isContent =
        path.indexOf("/shk") > -1 && path.indexOf("/shk/welcome") == -1;
      let isRead =
        path.indexOf("/read") > -1 && path.indexOf("/read/welcome") == -1;
      // console.log("curremtCourse", this.currentCourse);
      // let isAuthorized = true;
      let targetRoles = this.getCurrentCourseRoles();
      // console.log("targetRoles", targetRoles);
      let subjectLists = [];
      // this.userInfo &&
      //   (!this.userInfo.resourceCardVO ||
      //     !this.userInfo.resourceCardVO.resourceCardBalance)
      // let data = await getCourseList({
      //     productId: this.productId,
      //   });
      await this.getUserCourses();
      subjectLists = this.userCourses;
      // console.log(
      //   "this.isOnlyScsy",
      //   this.isOnlyScsy,
      //   isLab || this.isOnlyScsy || isContent || isRead || isZyk
      // );
      if (isLab || this.isOnlyScsy || isContent || isRead || isZyk) {
        // console.log("----data", data);
        if (isLab || this.isOnlyScsy || isContent || isRead) {
          // 没有权限跳转会工作台页面
          if (!subjectLists || !subjectLists.length) {
            // console.log("跳转到工作台");
            this.$router.replace("/desktop").catch((err) => err);
            return;
          }
        }
        // 设置当前课程列表
        this.setCourses(subjectLists);
      }
      // console.log("currentCourse", this.currentCourse);
      if (isExcludePage && !this.currentCourse.isLastUsedCourse) {
        // 显示添加课程弹窗
        // console.log("显示添加课程弹窗===");
        this.isAddCoursesAgain = false;
        // this.isAddCourseVisible = true
        this.triggerType = "被动";
        this.changeAddCourseDialogVisible(true, this.triggerType, false, true);
      } else if (
        (isLab || this.isOnlyScsy || isContent || isRead) &&
        !this.currentCourse.isLastUsedCourse
      ) {
        // 仿真实验室和上好课没有权限跳转到对应的欢迎页面
        this.isAddCoursesAgain = true;
        this.$router
          .replace(`${isContent ? "/shk" : path}/welcome`)
          .catch((err) => err);
      }
    },
    handleCloseNoticeDrawer() {
      this.showDrawer = false;
      this.noticeParentOnlyShowMask(false);
    },
    // 关闭
    hiddenGuideTip(e) {
      if (!this.showTip) {
        return;
      }
      let className =
        this.currentGuideTipClassName == "tip-occupy"
          ? "first-resource-item"
          : this.currentGuideTipClassName;
      let currentGuideTip = document.querySelector("." + className);
      let target = e.target;
      // console.log(
      //   "currentGuideTip",
      //   currentGuideTip,
      //   target,
      //   e.target,
      //   currentGuideTip.contains(target)
      // );
      if (currentGuideTip && currentGuideTip.contains(target)) {
        // console.log("点击当前引导区域，显示到下一个 引导");
        this.$refs.guideTip.handleNextTip();
      }
      // console.log("currentGuideTipClassName");
    },
    initMessageListener() {
      let that = this;
      let path = this.$route.path;
      let isBk =
        path.indexOf("/bk") > -1 ||
        path.indexOf("/jb") > -1 ||
        path.indexOf("/bj") > -1;
      window.addEventListener("message", async function (e) {
        // let isAddCourse = false;
        if (!e.data || typeof e.data != "string") {
          return;
        }
        let message = JSON.parse(e.data);
        console.log("mesage", message);
        let { type, data, params } = message;
        if (type == "mask") {
          // 显示遮罩
          that.isShowMask = data.visible;
          that.maskStyle = data;
        } else if (type === "addCoursesBook") {
          // console.log("message", params);
          // console.log("添加课程");
          // let {stageId,subjectId} = params
          // let { result: courses } = await getUserCoursesBooks();
          // console.log('courses',courses)
          // let currentCourse = await that.getCurrentChooseCourse(
          //   courses[0].courseId
          // );
          let isAuthorized = await that.judgeCurrentAuthorized(params);
          console.log("是否有权限", isAuthorized);
          // that.judgeCurrentAuthorized(params)
          if (isAuthorized) {
            isAddCourse = true;
            await that.getUserCourses(true);
          }
          // 重新获取当前课程第一个
        } else if (type == "deleteCoursesBook") {
          // console.log("message", params);
          // 删除课程
          let deleteDialog = that.$refs.deleteDialog;
          let { deleteIds } = params;
          that.setDeleteIds(deleteIds);
          // console.log('userCourses',that.userCourses)
          deleteDialog.handleCourseDelete(false);
          // console.log("deleteDialog", deleteDialog);
        } else if (type == "updateCoursesBook") {
          // console.log("更新课程", params);
          // 更新课程
          // console.log
          // let currentCourse = null;
          let { courseId } = params;
          let currentCourse = await that.getCurrentChooseCourse(courseId);
          console.log("当前课程", currentCourse);
          let course = null;
          console.log("isAddCourse 添加课程来的", isAddCourse);
          if ((currentCourse && !isAddCourse) || isAddCourse) {
            // 有权限的课程可以切换当前课程
            for (let i = 0; i < that.userCourses.length; i++) {
              let item = that.userCourses[i];
              if (item && item?.courseList?.length) {
                course = item.courseList.find(
                  (course) => course.courseId == courseId
                );
                if (course) {
                  break;
                }
              }
            }
            // let course = that.userCourses.find(
            //   (item) => item.courseId == courseId
            // );
            course = isAddCourse ? currentCourse : course;
            console.log("course", that.userCourses, course);
            localStorage.setItem(
              `${that.userInfo.userId}-` + CURRENTCOURSE,
              JSON.stringify(course)
            );
            updateLastUsedCourse({
              stageId: course.stageId,
              subjectId: course.subjectId,
              productId: isBk ? 7 : that.productId,
            });
            // 重新设置当前课程
            that.setCurrentCourse(course);
            isAddCourse = false;
          }
        }
      });
    },
    async getCurrentChooseCourse(courseId, stageId, subjectId) {
      // console.log("courseId,stageId,subjectId", courseId, stageId, subjectId);
      let currentCourse = null;
      // let { courseId } = params;
      let { result: stages } = await getStages();
      // console.log("学段", stages);
      stages.forEach((stage) => {
        stage.subjectList.forEach((subject) => {
          if (
            subject.course.courseId == courseId ||
            (stage.id == stageId && subject.id == subjectId)
          ) {
            subject.course.stageId = stage.id;
            subject.course.subjectId = subject.id;
            currentCourse = subject.course;
          }
        });
      });
      // console.log("当前课程", currentCourse);
      return currentCourse;
    },
    handleFeedbackDialogVisible(status = true) {
      this.deleteVisible = status;
      let callback = () => {
        this.deleteVisible = status;
      };
      this.noticeParentPageShowMask(status, callback, ".delete-course");
    },
    handleClose() {
      // console.log("关闭窗口", this.deleteIds);
      // this.deleteIds = [];
      this.handleFeedbackDialogVisible(false);
      // this.deleteVisible = false;
      this.$refs.addCourse.hideDialog("block");
    },
    handleDelete() {
      // 做真正的删除操作
      this.$refs.addCourse.updateUserCourseListMethod();
      this.handleFeedbackDialogVisible(false);
    },
    async handleSyncUserCourses() {
      let syncUserCourses = Cookie.get(SYNC_USER_COURSES) || false;
      if (!syncUserCourses) {
        let data = await request.get(api.work.syncUserCourses);
        // console.log("data", data);
        if (data.result) {
          Cookie.set(SYNC_USER_COURSES, true, {
            expires: 365,
          });
        }
      }
    },
    changeOpenSettingDialogVisible(status = true) {
      this.settingDialogVisible = status;
      let callback = () => {
        this.settingDialogVisible = status;
      };
      this.noticeParentPageShowMask(status, callback, ".custom-dialog");
      // }
    },
    getTime() {
      let date = new Date();
      return (
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
      );
    },
    // 初始化更新日志
    initUpdateNotice() {
      // 是否已经显示更新弹层
      let { status, date } = this.$global.IS_UPDATE;
      let isShowUpdateDrawer =
        Cookie.get(IS_SHOW_UPDATE_DRAWER + "|" + date) || false;
      this.showDrawer = !isShowUpdateDrawer && status;
      // console.log('showDrawer',showDrawer)
      if (this.showDrawer) {
        this.noticeParentOnlyShowMask(true);
      }
      if (this.showDrawer) {
        // 清楚之前的cookies
        let showDrawers = util.getCookie(IS_SHOW_UPDATE_DRAWER, true) || [];
        showDrawers.forEach((item) => {
          let [key] = item.split("=");
          Cookie.remove(key.trim());
        });
        Cookie.set(IS_SHOW_UPDATE_DRAWER + "|" + date, true, {
          expires: 365 * 2,
        });
      }
    },
    // 设置功能成功后的回调
    handleSetFeaturesSuccess() {
      this.getUserModuleAuth({
        // courseId: this.currentCourse.courseId,
      });
    },
    handleAddUseCourse(params) {
      let triggerType = params.triggerType || "主动";
      delete params.triggerType;
      let targetCourse = null;
      // 先前置判断是否是重新增加的课程 并且判断当前加入的课程是否是已经在课程列表中了
      let { stageId, subjectId } = params;
      console.log("v", this.isAddCoursesAgain);
      if (this.isAddCoursesAgain) {
        for (let i = 0; i < this.userCourses.length; i++) {
          let item = this.userCourses[i];
          if (item.id == stageId) {
            targetCourse = item.courseList.find(
              (subject) => subject.subjectId == subjectId
            );
          }
        }
        if (!targetCourse) {
          // 没有添加过课程
          this.addUseCourse(params, triggerType, true);
        } else {
          // 如果添加过课程直接设置为课程为当前课程
          localStorage.setItem(
            `${this.userInfo.userId}-` + CURRENTCOURSE,
            JSON.stringify(targetCourse)
          );
          this.setCurrentCourse(targetCourse);
          this.$refs.addCourse.cancel();
        }
      } else {
        console.log("添加课程", params, triggerType, this.isSchoolBased);
        this.addUseCourse(params, triggerType, true, true, this.isSchoolBased);
      }
      // 更新或添加用户最近使用课程信息
      this.updateLastUsedCourse(params);
    },
    handleCloseAddCourseDialog() {
      // 关闭弹窗设置为主动
      this.triggerType = "主动";
      this.isAddCourseVisible = false;
      // 重置
      this.isAddCoursesAgain = false;
      // if (this.isInIframe) {
      // 通知父页面显示遮罩
      // parent.window.postMessage(
      //   '{"key":"wxt","type":"mask","data":{"visible":true,"background":"#000000","opacity":0.5},"desc":"宿主遮罩"}',
      //   "*"
      // );
      this.noticeParentPageShowMask(false);
      // }
    },
    handleCloseChooseDialog() {
      // 关闭弹窗设置为主动
      this.triggerType = "主动";
      this.chooseDialogFlag = false;
    },
    changeAddCourseDialogVisible(
      status,
      triggerType,
      isSchoolBased = false,
      isAddCoursesAgain = false
    ) {
      // console.log("isAddCoursesAgain", isAddCoursesAgain);
      if (status) {
        this.isSchoolBased = isSchoolBased;
        this.openCourse(
          !isAddCoursesAgain ? this.userCourses : [],
          triggerType,
          isSchoolBased,
          isAddCoursesAgain
        );
      }
      let callback = () => {
        this.isAddCourseVisible = true;
      };
      this.noticeParentPageShowMask(status, callback, ".add-course-dialog");
      // }
    },
    changeRizhiDialogVisible(status) {
      // console.log("status", status);
      // this.rizhiDialogVisible = status;;
      this.showDrawer = status;
      // if (this.isInIframe) {
      // 通知父页面显示遮罩
      // parent.window.postMessage(
      //   '{"key":"wxt","type":"mask","data":{"visible":true,"background":"#000000","opacity":0.5},"desc":"宿主遮罩"}',
      //   "*"
      // );
      // let callback =  ()=> {
      //   this.showDrawer = status;
      // };
      // this.noticeParentPageShowMask(status, callback);
      this.noticeParentOnlyShowMask(status);
      // }
    },
    noticeParentOnlyShowMask(status = true) {
      // if (this.isInIframe) {
      //   window.XEP.dialog.mask(status);
      // }
    },
    // noticeParentPageShowMask(status = true, callback, className) {
    //   console.log("通知弹窗", status);
    //   if (this.isInIframe) {
    //     // 通知父页面显示遮罩
    //     // console.log("window.XEP.dialog", typeof window.XEP.dialog.mask);
    //     if (window.XEP && window.XEP.dialog) {
    //       if (status) {
    //         window.XEP.dialog.showDialog(callback, className, ".v-modal");
    //       }
    //       window.XEP.dialog.mask(status);
    //     }
    //   }
    // },
    noticeParentPageShowMask(status = true, callback, className) {
      // console.log("通知弹窗", status);
      // if (this.isInIframe) {
      //   // 通知父页面显示遮罩
      //   parent.window.postMessage(
      //     `{"key":"wxt","type":"mask","data":{"visible":${status},"background":"#000000","opacity":0.5},"desc":"宿主遮罩"}`,
      //     "*"
      //   );
      //   if (status) {
      //     // let asideWidth =
      //     //   parent.document.getElementById("xep-platform-aside").offsetWidth;
      //       let dialogs = document.getElementsByClassName("el-dialog");
      //       for (let i = 0; i < dialogs.length; i++) {
      //         let dialogWidth = dialogs[i].style.width;
      //         // console.log("dialogs[i]", dialogs[i], dialogWidth);
      //         dialogs[i].style.position = "relative";
      //         dialogs[i].style.left = -(this.asideWidth / 2) + "px";
      //       }
      //       // let dialog = dialogs.filter((item) => item.style.display != "none");
      //       // console.log("当前的dialog", dialogs);
      //     }
      //   }
      // }
      // console.log("通知弹窗", status);
      if (this.isInIframe) {
        // 通知父页面显示遮罩
        // console.log("window.XEP.dialog", typeof window.XEP.dialog.mask);
        if (window.XEP && window.XEP.dialog) {
          if (status) {
            window.XEP.dialog.showDialog(callback, className, ".v-modal");
          }
          window.XEP.dialog.mask(status);
        }
      }
    },
    // noticeParentPageShowMask(status = true) {
    //   // console.log("通知弹窗", status);
    //   if (this.isInIframe) {
    //     // 通知父页面显示遮罩
    //     parent.window.postMessage(
    //       `{"key":"wxt","type":"mask","data":{"visible":${status},"background":"#000000","opacity":0.5},"desc":"宿主遮罩"}`,
    //       "*"
    //     );
    //     if (status) {
    //       // let asideWidth =
    //       //   parent.document.getElementById("xep-platform-aside").offsetWidth;
    //       let dialogs = document.getElementsByClassName("el-dialog");
    //       for (let i = 0; i < dialogs.length; i++) {
    //         let dialogWidth = dialogs[i].style.width;
    //         // console.log("dialogs[i]", dialogs[i], dialogWidth);
    //         dialogs[i].style.position = "relative";
    //         dialogs[i].style.left = -(this.asideWidth / 2) + "px";
    //       }
    //       // let dialog = dialogs.filter((item) => item.style.display != "none");
    //       // console.log("当前的dialog", dialogs);
    //     }
    //   }
    // },
    changeFeedbackDialogVisible(status) {
      this.feedbackDialogVisible = status;
      let callback = () => {
        this.feedbackDialogVisible = status;
      };
      // if (this.isInIframe) {
      this.noticeParentPageShowMask(status, callback, ".feedback");
      // }
    },
    async toPath(pathName, api) {
      const operate = api || "push";
      // console.log("pathName", pathName);
      // console.log("bk", pathName);
      if (pathName === "/tech") {
        // console.log('judgeRightPage',this.isOnlyScsy)
        this.isOnlyScsy ? localStorage.setItem(WHEREISFROMLAB, "tech") : null;
        pathName = this.isOnlyScsy ? "/lab/" : pathName;
        this.$router[operate]({
          path: pathName,
          // query: util.queryToTechByTextbook(this.textbooks[0]),
        });
      } else if (pathName === "/exam") {
        this.$router[operate]({
          path: pathName,
          // query: util.queryToPageByCourse(this.userCourses[0]),
        });
      } else if (pathName === "/mock") {
        this.$router[operate]({
          path: pathName,
          // query: util.queryToPageByCourse(this.userCourses[0]),
        });
      } else if (pathName === "/bk") {
        this.$router[operate]({
          path: pathName,
          // query: util.queryToPageByCourse(this.userCourses[0]),
        });
      } else if (pathName === "/school-based") {
        // let xbBasePath = {
        //   path: pathName,
        //   query: await util.queryToSchoolBased(),
        // };
        let query = await this.queryToSchoolBased();
        // console.log('query',query)
        //去掉教材id选项
        // delete query.textbookId;
        //刷新页面
        this.$router[operate]({
          path: `${pathName}?${qs.stringify(query)}`,
          // query: util.queryToPageByCourse(this.userCourses[0]),
        });
        // window.location.href = `${pathName}?${qs.stringify(query)}`;
        // this.$router.push(xbBasePath);
      } else {
        // console.log("pathName");
        this.$router.push({ path: pathName });
      }
      if (pathName && pathName.indexOf("/school-based") > -1) {
        this.isChangeChild = true;
      }
      // console.log(pathName, api);
    },
    async handleAddNewCourse(courseId, stageId, subjectId) {
      let currentCourse = await this.getCurrentChooseCourse(
        courseId,
        stageId,
        subjectId
      );
      // console.log("添加新课程---", currentCourse);
      if (currentCourse) {
        localStorage.setItem(
          `${this.userInfo.userId}-` + CURRENTCOURSE,
          JSON.stringify(currentCourse)
        );
        this.addUseCourse(
          {
            stageId,
            subjectId,
            courseId,
          },
          "被动",
          false,
          false
        );
        // 重新设置当前课程
        this.setCurrentCourse(currentCourse);
        // this.getUserCourses()
        // 重新获取课程列表
        this.loadTextbooks();
      } else {
        console.log("没有权限");
      }
    },
    // 添加教材成功
    async addTextbookSuccess(textbookId, info) {
      // console.log("添加教材成功");
      // 重新加载课程
      await this.getUserCourses();
      // 重新加载教材
      await this.loadTextbooks();
      // let result = await this.loadTools({
      //   courseId: this.currentCourse.courseId,
      // });
      // let finalResult = [];
      // // if (data.code === 200) {
      // let groupNum = Math.ceil(result.length / 4);
      // for (let i = 0; i < groupNum; i++) {
      //   finalResult.push(result.slice(i * 4, (i + 1) * 4));
      // }
      // //   return finalResult;
      // // }
      // this.setUserTools(finalResult);
      // 调用统计方法
      tracker.constructTracker(info, this.userInfo, isInIframe);
    },
    changeSuggestionBanner() {
      this.$refs.suggestionBanner.showSuggestion();
    },
    showSetDialogFunction(status) {
      console.log("showSetDialogFunction", status);
      this.showSetDialog = status;
    },
    toLoginLayout() {
      this.$refs.childComponent.toLogin();
    },
    openNoAuthDialog() {
      this.$refs.childComponent.collectBtnDialog();
    },
    closeTextbookEncyclopediaDialog() {
      this.textbookEncyclopediaDialogStatus = false;
    },
    openTextbookEncyclopediaDialog() {
      this.textbookEncyclopediaDialogStatus = true;
    },
    // 提供方法给子组件调用以等待 iframe 加载
    // async waitForIframeLoad() {
    //   if (!this.loginIframeLoadPromise) {
    //     // 重新初始化 Promise
    //     await this.initIframePromise();
    //   }

    //   try {
    //     console.log("Waiting for iframe to load...");
    //     const result = await this.loginIframeLoadPromise;
    //     console.log("Iframe loaded successfully with result:", result);
    //     return result;
    //   } catch (error) {
    //     console.error("Error waiting for iframe:", error);
    //     return false;
    //   }
    // },
    // 提供方法给子组件调用以等待 iframe 加载
    async waitForIframeLoad() {
      try {
        // console.log("Waiting for sync login...");
        if (!this.isLoginSynced) {
          await this.syncLogin();
        }
        return true;
      } catch (error) {
        console.error("Error during sync login:", error);
        return false;
      }
    },
    async syncLogin() {
      try {
        const loginUrl = `https://${protocolName}.xkw.com/login?service=${encodeURIComponent(
          "https://auth.zxxk.com/user/asynclogin"
        )}`;
        // console.log("loginUrl", loginUrl);
        // console.log("Starting sync login request...");
        // 创建一个 iframe 来加载同步登录页面
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = loginUrl;

        const loginPromise = new Promise((resolve) => {
          iframe.onload = () => {
            // console.log("Sync login iframe loaded");
            // 给一点时间让 cookie 设置生效
            setTimeout(() => {
              document.body.removeChild(iframe);
              resolve(true);
            }, 1000);
          };
        });

        document.body.appendChild(iframe);
        await loginPromise;

        // console.log("Sync login completed");
        this.isLoginSynced = true;
        return true;
      } catch (error) {
        console.error("Sync login failed:", error);
        throw error;
      }
    },
  },
  components: {
    TextbookEncylopedia,
    Aside,
    Header,
    feedBackModal,
    timeLineModal,
    customSet,
    chooseDialog,
    suggestion,
    addCourse,
    NoticeDrawer,
    DeleteDialog,
    GuideTip,
    ScrollTop,
    CostDialog,
  },
};
</script>
<style lang="scss" scoped>
.page {
  position: relative;
}

.layout-content {
  position: relative;
  // overflow: auto;
  margin-left: 130px;
  height: 100vh;
  min-height: 100vh;
  // background: #f2f5f7;
  // overflow-y: scroll;
  & > div {
    height: 100%;
  }
  &.is-full-screen {
    margin-left: 0;
  }
  &.no-show-skeleton {
    margin: 0;
    height: auto;
  }

  &.is-folded-layout-content {
    margin-left: 64px;
  }
  &.no-show-aside {
    margin-left: 0;
    padding-left: 0;
  }
  &.show-xep-aside {
    margin-left: 0;
    padding-left: 64px;
  }
  &.showSetDialog {
    overflow: hidden;
  }
}

.bread-crumb {
  height: 40px;
  line-height: 38px;
  background-color: rgb(248, 255, 154);
}
.mask_1 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  .login_popup {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 570px;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    overflow: hidden;
    z-index: 1;
    .iconfont {
      position: absolute;
      right: 10px;
      cursor: pointer;
      top: 10px;
      font-size: 12px;
      color: #666;
      font-weight: bold;
      &:hover {
        color: #333;
      }
    }
  }
}
.login-iframe {
  position: fixed;
  z-index: -100;
  top: -1000px;
}
</style>
<style>
/* 路由的简单过渡动画效果 */
.v-enter {
  opacity: 0;
}

.v-enter-to {
  opacity: 1;
}

.v-enter-active {
  transition: 0.3s;
}

.v-leave {
  opacity: 1;
}

.v-leave-to {
  opacity: 0;
}

.v-leave-active {
  transition: 0.3s;
}

#cover {
  position: absolute;
  left: 0px;
  top: 0px;
  background: var(-----xkw-mask-color, rgba(0, 0, 0, 0.5));
  width: 100%; /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
  height: 100%;
  filter: alpha(opacity=60); /*设置透明度为60%*/
  z-index: 3000;
}
</style>
